import { formatNumber } from '@eika-infrastruktur/format';
import type { DataPoint } from '@generated-types';
import type { VictoryChartDataPoint } from '@graph-types';

const withKrSuffix = (value: string) => `${value} kr`;
export const formatNok = (amount: number) => withKrSuffix(formatNumber(amount, 0));

const withPercentageSuffix = (value: string) => `${value} %`;

export const formatPercentage = (amount: number, fractals?: number) =>
    withPercentageSuffix(formatNumber(amount, fractals));

export const toVictoryChartFriendlyDataPoint = ({ time, value }: DataPoint): VictoryChartDataPoint => ({
    x: time,
    y: value,
});
